<dash-header></dash-header>

<main class="h-full w-full p-4 md:p-6">
  <router-outlet></router-outlet>
</main>
